export default "__VITE_ASSET__4cc68a45__"